<template>
  <div>
    <div class="other-attributes">
      
      <div class="other-attributes__wrapper"  v-for="(item, index) in list"
      :key="index">
          <div class="other-attributes__item" :class="item.attribute.name">
            <strong class="other-attributes__title" :title="attributeLabel(item.attribute)">{{ attributeLabel(item.attribute) }}</strong>
            <div class="other-attributes__value">
              <template v-if="item.attribute.pivot.override === null && item.attribute.pivot.value === null">
                <span>
                  -
                </span>
              </template>
              <template v-else>
                
              <template v-if="item.attribute.pivot.override != null">
                <span>{{ item.attribute.pivot.override }}</span>
              </template>
              <template v-else>
                <span>{{ item.attribute.pivot.value }}</span>
              </template>
              
            </template> 
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OtherAttributesList",
  props: {
    items: {
      type: Array,
      required: true,
    },
    bundle: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.initList();
  },
  watch: {
    items: {
      handler() {
        this.initList();
      },
      deep: true,
    },
  },
  computed: {
    attributeLabel(){
      return (attribute) => {
        const langShortCode = this.$store.getters.langShortcode;
        if(attribute.displayName[langShortCode]) return String(attribute.displayName[langShortCode]).trim();
        if(attribute.isBundleAttribute){
          return String(this.$t("ARTICLE-BUNDLE-ATTRIBUTE-" + attribute.name.toUpperCase())).trim();
        }
        
        return String(this.$t(attribute.name.toUpperCase())).trim();
      }
    }
  },
  methods: {
    initList() {
      this.list = this.items.filter((el) =>{
        if([
          "tiltable",
          "bridge_percentage",
          "overhang_percentage",
          "transparent",
          "friction",
          "length_bars",
          "bars",
          "stamp_force",
          "kisoft_adp_program",
          "nesting_type",
          "width_bars",
          "nesting_bonus",
          "nesting_same_type_required",
          "nesting_mix_sizes",
          "nesting_tolerance_plus",
          "nesting_tolerance_minus",
          "robot_program",
          "narrowing",
          "productionline",
          "kisoft_adp_handling",
          "strength",
          "loading_hint",
          "adp_program",
          "area_pressure",
          "height",
          "width",
          "length",
          "weight",
          "container_suggestion"
        ].includes(el.attribute.name)) return false;
          if(el.attribute.type === 'image') return false;
          if(!el.attribute.isActive) return false;
          if(el.attribute.isValueChain) return false;
          return true;
      }).sort((a, b) => {
        const aName = String(this.attributeLabel(a.attribute));
        const bName = String(this.attributeLabel(b.attribute));
        return aName.localeCompare(bName);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.other-attributes {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 1em;
  margin-top: .25em;

  &__wrapper{
      position: relative;
      flex: 0 1 25%;
      min-height: 50px; 
      flex-direction: row;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      flex: 0 1 280px;
      // @media (min-width:2301px){
      //   flex: 0 1 12%;
      // }
      
      // @media (min-width:2000px) and (max-width: 2300px){
      //   flex: 0 1 15%;
      // }
      // @media (min-width:1800px) and (max-width: 1999px){
      //   flex: 0 1 20%;
      // }
      // @media (max-width:1600px){
      //   flex: 0 1 30%;
      // }
      // @media (max-width:1200px){
      //   flex: 0 1 50%;
      // }
      // @media (max-width:700px){
      //   flex: 0 1 100%;
      // }
      
    }

  &__item {
    flex: 1;
    margin: .25em;
    padding: .25em .10em;
    flex-direction: row;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #cdcdcd !important;
  }

  &__title{
    flex: 0 1 65%;
    
  }

  &__value{
    flex: 0 1 35%;
    font-weight: 400;
  }

  &__title,
  &__value {
    font-family: Arial, sans-serif;
    font-size: 14px;
    line-height: 18px;
    color: #666666;
    display: -webkit-box;

    text-align: left;
    padding-left: 1em;
    line-break: auto;
    white-space: pre-wrap;
    word-break: break-word;
    -webkit-line-clamp: 2; /* number of lines to show */
    line-clamp: 2; 
    -webkit-box-orient: vertical;
    overflow: hidden;

  }

  
  
}
</style>
